import {Popconfirm, PopconfirmProps} from 'antd'

import {CheckCircleIcon} from 'common/components'

export default function Confirm(props: PopconfirmProps) {
  return (
    <Popconfirm
      okText="confirm"
      cancelText="cancel"
      icon={<CheckCircleIcon width={16} height={16} />}
      {...props}
    />
  )
}
